import React, { useEffect, useRef } from 'react';

import application from 'application';

import NavigableList from 'generics/components/navigable-list';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import {
  toClassName
} from './utilities';

import './index.scss';

function FontFamilySelector(props) {

  const fontFamilySelectorMainReference = useRef(null);

  useEffect(function onLoad() {

    displayFontFamiliesMenu();

    loadFontFamilies();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getFontFamiliesReferences() {

    const fontFamilies = application.system.getFontFamilies();

    const fontFamiliesReferences = {};

    for (let fontFamily of fontFamilies) {

      fontFamiliesReferences[fontFamily.name] = 1;

    }

    return fontFamiliesReferences;

  }

  function loadFontFamilies() {

    const fontFamiliesReferences = getFontFamiliesReferences();

    return application.externalFontFamiliesManager.activateFontFamilies(fontFamiliesReferences);

  }

  function displayFontFamiliesMenu() {

    const element = fontFamilySelectorMainReference.current;
    const anchorElement = element.parentNode;
    const viewportElement = void 0;
    const verticalOffset = 10;
    const horizontalOffset = 0;
    const startSide = 'bottom';
    const placeOnCenter = true;
    const positionableSides = void 0;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  function renderFontFamily(item, index, selectedItemIndex) {

    const itemAttributes = {
      className: 'font-family-item navigable-list-item ' + toClassName(item),
      style: {
        fontFamily: item.value
      }
    };

    if (index === selectedItemIndex) {
      itemAttributes.className += ' selected';
    }

    return <div {...itemAttributes}>
      <span className="ellipsis">{item.name}</span>
    </div>;
  }

  function renderMain() {

    const mainAttributes = {
      id: 'font-family-selector-main',
      ref: fontFamilySelectorMainReference
    };

    const fontFamilies = application.system.getFontFamilies();

    const navigableListProperties = {
      items: fontFamilies,
      selectedItemIndex: findIndexByPropertyValue(fontFamilies, 'value', props.fontFamily),
      itemRenderer: renderFontFamily,
      noScroll: true,
      onSelect(item) {
        props.onChange(item);
      }
    };

    return <div {...mainAttributes}>
      <NavigableList {...navigableListProperties} />
    </div>;

  }

  return renderMain();

}

export default FontFamilySelector;